import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class CompanyManagementViewService {

  public clickedNewCompany$: Subject<any> = new Subject();
   
  constructor() 
  {   

  }

 
}




